import React from "react";
import type { FlagRecord } from "./flags";

export type FeatureFlagContextValue = {
  flags: FlagRecord;
  loaded: boolean;
};

const FeatureFlagContext = React.createContext<FeatureFlagContextValue>({
  flags: {},
  loaded: false
});

export default FeatureFlagContext;
